var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "edit-circle-large.fb8b4996.png","uri@2x": __webpack_public_path__ + "edit-circle-large.d52fe2cf.png","uri@3x": __webpack_public_path__ + "edit-circle-large.adaae745.png",
    width: 140,
    height: 140
});